import React from "react";

const InSetBoxShadow = ({ children, style, className }) => {
  return (
    <div
      style={{
        backgroundColor: "#FFFFFF",
        borderRadius: "5px",
        overflow: "hidden",
        ...style,
      }}
      className={`new-box-shadow ${className}`}
      dir="rtl"
    >
      {children}
    </div>
  );
};

export default InSetBoxShadow;
